import { SVGProps } from 'react';

export const RightArrowIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="10" height="4" viewBox="0 0 10 4" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fill="currentColor"
        d="M7.01407 3.52873C7.12607 3.2674 7.24274 3.0294 7.36407 2.81473C7.4854 2.60007 7.6114 2.40873 7.74207 2.24073H7.04527e-05V1.28873H7.74207C7.6114 1.12073 7.4854 0.929401 7.36407 0.714734C7.24274 0.490734 7.12607 0.252734 7.01407 0.000734031H7.86807C8.44674 0.682067 9.07207 1.19073 9.74407 1.52673V2.00273C9.0814 2.3294 8.45607 2.83807 7.86807 3.52873H7.01407Z"
      />
    </svg>
  );
};
